<template>
  <div>
    <el-table :data="kpiConfigList" border :span-method="objectSpanMethod" header-cell-class-name="headerStyle" cell-class-name="cellStyle">
      <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label"></el-table-column>
      <el-table-column prop="kpi" label="KPI" width="270"></el-table-column>
      <el-table-column label="权重" width="180">
        <template slot-scope="scope">
          <el-input v-if="(scope.row.kpiType==='季度考核' || scope.row.kpiType==='年度考核') && canEditWeight" v-model="scope.row.kpiWeight" @change.native.prevent="inputWeight(scope.$index, scope.row.kpiWeight, kpiConfigList)" placeholder="请输入权重百分比">
            <i slot="suffix" class="el-input__icon">%</i>
          </el-input>
          <div v-else-if="!canEditWeight && (scope.row.kpiType==='季度考核' || scope.row.kpiType==='年度考核')">{{scope.row.kpiWeight}} %</div>
        </template>
      </el-table-column>
      <el-table-column label="规则调整" width="100">
        <template slot-scope="scope">
          <div v-if="hasOperation && scope.row.kpiType==='季度考核'">
            <span v-if='scope.row.kpiAchCondition!==null && scope.row.kpiAchCondition!==undefined'>
              <span class="operation"  @click="changeKpiRule('edit',kpiConfigList,scope.row)">编辑</span>
              <span class="operation operation_R" @click="changeKpiRule('delete','',scope.row)">删除</span>
            </span>
            <span v-else class="operation" @click="changeKpiRule('add',kpiConfigList,scope.row)">添加</span>
          </div>
          <div class="center_m" v-if="!hasOperation && scope.row.kpiType==='季度考核'">
            <span class="operation" @click="changeKpiRule('view',kpiConfigList,scope.row)">查看</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <kpi-rule ref="kpiRuleRef" :kpiConfigList = 'kpiConfigList' />
  </div>
</template>
<script>
import kpiRule from './kpiRule'
export default {
  name: 'kpiTable',
  components: {
    kpiRule
  },
  props: {
    kpiConfigList: Array,
    canEditWeight: Boolean,
    hasOperation: Boolean
  },
  data () {
    return {
      type: 'create',
      columns: [
        {
          prop: 'year',
          label: '年份'
        },
        {
          prop: 'channel',
          label: '渠道'
        },
        {
          prop: 'position',
          label: '职位'
        },
        {
          prop: 'quarter',
          label: '季度'
        },
        {
          prop: 'kpiType',
          label: 'KPI类型'
        }
      ],
      typeNameArr: [],
      typeNamePos: 0,
      storeArr: [],
      storePos: 0,
      feeArr: [],
      feePos: 0,
      quarterArr: [],
      quarterPos: 0,
      typeArr: [],
      typePos: 0,
      kpiArr: [],
      kpiPos: 0
    }
  },
  computed: {},
  created () {
    this.merage()
  },
  methods: {
    // 绑定填写的值
    inputWeight (index, val, rows) {
      rows[index].kpiWeight = val
    },
    merageInit () {
      this.typeNameArr = []
      this.typeNamePos = 0
      this.storeArr = []
      this.storePos = 0
      this.feeArr = []
      this.feePos = 0
      this.quarterArr = []
      this.quarterPos = 0
      this.typeArr = []
      this.typePos = 0
      this.kpiArr = []
      this.kpiPos = 0
    },
    merage () {
      this.merageInit()
      for (let i = 0; i < this.kpiConfigList.length; i += 1) {
        if (i === 0) {
          // 第一行必须存在
          this.typeNameArr.push(1)
          this.typeNamePos = 0
          this.storeArr.push(1)
          this.storePos = 0
          this.feeArr.push(1)
          this.feePos = 0
          this.quarterArr.push(1)
          this.quarterPos = 0
          this.typeArr.push(1)
          this.typePos = 0
        } else {
          // 判断当前元素与上一个元素是否相同,eg：this.typeNamePos 是 this.typeNameArr序号
          // 第一列
          // eslint-disable-next-line no-lonely-if
          if (this.kpiConfigList[i].year === this.kpiConfigList[i - 1].year) {
            this.typeNameArr[this.typeNamePos] += 1
            this.typeNameArr.push(0)
          } else {
            this.typeNameArr.push(1)
            this.typeNamePos = i
          }
          // 第二列
          if (
            this.kpiConfigList[i].channel === this.kpiConfigList[i - 1].channel &&
            this.kpiConfigList[i].year === this.kpiConfigList[i - 1].year
          ) {
            this.storeArr[this.storePos] += 1
            this.storeArr.push(0)
          } else {
            this.storeArr.push(1)
            this.storePos = i
          }
          // 第三列
          if (
            this.kpiConfigList[i].role === this.kpiConfigList[i - 1].role &&
            this.kpiConfigList[i].channel === this.kpiConfigList[i - 1].channel &&
            this.kpiConfigList[i].year === this.kpiConfigList[i - 1].year
          ) {
            this.feeArr[this.feePos] += 1
            this.feeArr.push(0)
          } else {
            this.feeArr.push(1)
            this.feePos = i
          }
          // 第四列
          if (
            this.kpiConfigList[i].quarter === this.kpiConfigList[i - 1].quarter &&
            this.kpiConfigList[i].role === this.kpiConfigList[i - 1].role &&
            this.kpiConfigList[i].channel === this.kpiConfigList[i - 1].channel &&
            this.kpiConfigList[i].year === this.kpiConfigList[i - 1].year
          ) {
            this.quarterArr[this.quarterPos] += 1
            this.quarterArr.push(0)
          } else {
            this.quarterArr.push(1)
            this.quarterPos = i
          }
          // 第5列
          if (
            this.kpiConfigList[i].kpiType === this.kpiConfigList[i - 1].kpiType &&
            this.kpiConfigList[i].quarter === this.kpiConfigList[i - 1].quarter &&
            this.kpiConfigList[i].role === this.kpiConfigList[i - 1].role &&
            this.kpiConfigList[i].channel === this.kpiConfigList[i - 1].channel &&
            this.kpiConfigList[i].year === this.kpiConfigList[i - 1].year
          ) {
            this.typeArr[this.typePos] += 1
            this.typeArr.push(0)
          } else {
            this.typeArr.push(1)
            this.typePos = i
          }
        }
      }
    },
    // 单元格合并
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 第一列的合并方法
        const row1 = this.typeNameArr[rowIndex]
        const col1 = row1 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row1,
          colspan: col1
        }
      } else if (columnIndex === 1) {
        // 第二列的合并方法
        const row2 = this.storeArr[rowIndex]
        const col2 = row2 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row2,
          colspan: col2
        }
      } else if (columnIndex === 2) {
        // 第三列的合并方法
        const row3 = this.feeArr[rowIndex]
        const col3 = row3 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row3,
          colspan: col3
        }
      } else if (columnIndex === 3) {
        // 第4列的合并方法
        const row4 = this.quarterArr[rowIndex]
        // console.log(row4)
        const col4 = row4 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row4,
          colspan: col4
        }
      } else if (columnIndex === 4) {
        // 第5列的合并方法
        const row5 = this.typeArr[rowIndex]
        const col5 = row5 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row5,
          colspan: col5
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    },
    // KPI规则弹出
    // type -- 类型
    // kpiConfigList -- 全部数据
    // row -- 当前行
    changeKpiRule (type, kpiConfigList, row) {
      // console.log(this.kpiConfigList)
      this.$refs.kpiRuleRef.change(type, kpiConfigList, row)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
